/* eslint-disable no-use-before-define */
import React from 'react'
import { FieldArray } from 'formik'
import { Fields, isEmpty, } from '../../twd/twd'
import { getAccounts, } from '../use-orders'


export const Form = ({
    handleSubmit,
    errors,
}) => {

    const hasAccount = getAccounts().length>0

    const [btnEl, setBtnEl] = React.useState(null)

    return <React.Fragment>
        <form onSubmit={handleSubmit}>
        <div className="container">
        <div className="row vertical-offset-sm">
        <div className={"col-md-5"}>
            <fieldset>
            <FieldArray
                name="accounts"
                disabled={!hasAccount}
                render={(args) => {
                    return <Fields.SelectMulti
                        dataName="orders-accounts"
                        label="Select one or more accounts"

                        emptyText=''
                        error={errors.accounts}

                        showSelectAll={hasAccount}
                        allText='All accounts selected'
                        options={ getAccounts().map(a => ({ label:a.title, value:a.acctNo, })) }
                        style={{marginBottom:'0px'}}
                        optionCheckboxLabelConfig={{
                            className:"text-truncate"
                        }}

                        placeholder={({emptyText, allText, values, options}) => {
                            let isNone = isEmpty(values)
                            if (isNone) return emptyText

                            let isAll = values.length>0 && values.length === options.length
                            if (isAll) return allText

                            let selected = options
                                .filter(a => values.indexOf(a.value)>=0)

                            let n = selected.length
                            if (n===0) return emptyText

                            return `${n} of ${options.length} accounts selected`
                        }}

                        onBlur={() => {
                            if (errors.accounts || !btnEl) return
                            btnEl.click()
                        }}

                        {...args}
                    />
                }}
            />
                <label className="field-status has-error">{errors.accounts}</label>
            </fieldset>
            <button ref={setBtnEl} type="submit" name="ts" style={{display:'none'}}>Change Account</button>
        </div>
        </div>
        </div>
        </form>
    </React.Fragment>

}



// WEBPACK FOOTER //
// ./src/orders/accounts/form.js